module.exports = __webpack_public_path__ + "static/media/icon_expired.b0f6cd38.svg";